import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/administaration',
    name: 'Login',
    meta: { title: '登录',showFoot:false },
    component: () => import('../views/Login.vue')
  },
  {
    path:'/Mobilehome',
   name:'Mobilehome',
   meta:{title:'湖北光舜科技有限公司'},
   component:()=>import('../views/MobileHome.vue')
  },
  {
    path: '/',
    // redirect: '/',
    meta: { title: '湖北光舜科技有限公司' },
    component: ()=>import('../views/devPage/Home.vue')
  },
  {
    path: '/home',
    name: 'Home',
    meta: { title: '湖北光舜科技有限公司' },
    component: ()=>import('../views/devPage/Home.vue')
  },
  {
    path: '/product/:id',
    name: 'product',
    meta: { title: '产品体系' },
    component: ()=>import('../views/devPage/productList.vue')
  },
  {
    path: '/newsCenter/:id',
    name: 'newsCenter',
    meta: { title: '新闻中心' },
    component: ()=>import('../views/devPage/news.vue')
  },
  {
    path: '/textInfo',
    name: 'textInfo',
    meta: { title: '详情' },
    component: ()=>import('../views/devPage/textInfo')
  },
  {
    path: '/industry/:id',
    name: 'industry',
    meta: { title: '行业应用' },
    component: ()=>import('../views/devPage/industry.vue')
  },
  {
    path: '/aboutUs/:id',
    name: 'aboutUs',
    meta: { title: '关于我们' },
    component: ()=>import('../views/devPage/aboutUs.vue')
  },
  {
    path: '/abc',
    name: 'abc',
    meta: { title: '测试' },
    component: ()=>import('../views/devPage/abc.vue')
  },
  {
    path: '/recruit/:id',
    name: 'recruit',
    meta: { title: '人才招聘' },
    component: ()=>import('../views/devPage/recruit.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { title: '联系我们' },
    component: ()=>import('../views/devPage/contact.vue')
  },
  
  {
    path:'/homeManage',
    name:'homeManage',
    //itemSystem
    redirect: '/itemSystem',
    meta: { title: '主页管理',showFoot:false },
    component: () => import('../views/HomeManage.vue'),
    children: [
      {
        path: '/scrollImage',
        name: 'scrollImage',
        meta: { title: '轮播图管理',showFoot:false },
        component: () => import('../components/homeManage/scrollImage.vue'),
      },
      {
        path: '/newsAdd',
        name: 'newsAdd',
        meta: { title: '新闻管理',showFoot:false },
        component: () => import('../components/editor/newsAdd.vue'),
      },
      {
        path: '/news',
        name: 'news',
        meta: { title: '新闻中心',showFoot:false },
        component: () => import('../components/homeManage/news.vue'),
      },
      {
        path: '/system',
        name: 'system',
        meta: { title: '体系类别',showFoot:false },
        component: () => import('../components/homeManage/system.vue'),
      },
      {
        path: '/itemSystem',
        name: 'itemSystem',
        meta: { title: '产品体系管理',showFoot:false },
        component: () => import('../components/homeManage/itemSystem.vue'),
      },
      {
        path: '/BusinessList',
        name: 'BusinessList',
        meta: { title: '行业' ,showFoot:false},
        component: () => import('../components/business/BusinessList.vue'),
      },
      {
        path: '/Industry',
        name: 'Industry',
        meta: { title: '行业应用' ,showFoot:false},
        component: () => import('../components/business/Industry.vue'),
      },
      {
        path: '/talents',
        name: 'talents',
        meta: { title: '人才招聘',showFoot:false },
        component: () => import('../components/companyInfo/talents.vue'),
      },{
        path: '/talentsAdd',
        name: 'talentsAdd',
        meta: { title: '培训发展',showFoot:false },
        component: () => import('../components/editor/talentsAdd.vue'),
      },
      {
        path: '/itemSystemAdd',
        name: 'itemSystemAdd',
        meta: { title: '产品体系',showFoot:false},
        component: () => import('../components/editor/itemSystemAdd.vue'),
      },
      
      {
        path: '/IndustryAdd',
        name: 'IndustryAdd',
        meta: { title: '行业应用',showFoot:false },
        component: () => import('../components/editor/IndustryAdd.vue'),
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        meta: { title: '关于我们',showFoot:false },
        component: () => import('../components/companyInfo/aboutUs.vue'),
      },
      {
        path: '/aboutUsAdd',
        name: 'aboutUsAdd',
        meta: { title: '关于我们' ,showFoot:false},
        component: () => import('../components/editor/aboutUsAdd.vue'),
      },
      {
        path: '/companyInfo',
        name: 'companyInfo',
        meta: { title: '公司信息',showFoot:false },
        component: () => import('../components/companyInfo/companyInfo.vue'),
      }
    ]
  }

]

const router = new VueRouter({
  routes
})

export default router
